// 判断无分销订单数据展示提示
// 1 暂无订单
// 2 暂无分销订单 无代发订单，且有自发订单
// 3 没有绑定店铺  绑定店铺的判断是最前面
// 4 渠道侧，无代发，无自发，有店铺
export const HAS_DISORDER_1 = 1
export const HAS_DISORDER_2 = 2
export const HAS_DISORDER_3 = 3
export const HAS_DISORDER_4 = 4

// 左右布局
export const NEW_LAYOUT_KEY = 'vertical'
// 垂直布局
export const OLD_LAYOUT_KEY = 'horizontal'
// 订单管理布局
export const ORDER_LAYOUT = 'ORDER_LAYOUT'

// 订单左右布筛选展示
export const ORDER_VERTICAL = 'order_vertical'
